import { Box, Button, Chip, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Stack, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CalendarIcon, ClockIcon, CloseLineIcon, DeleteIcon, EmailIcon, LocationIcon, PhoneIcon, PlusIcon, UserIcon } from '../../components/IconComponent'
import { useTranslation } from 'react-i18next';
import { formatDateToDDMMYYYYHHSSFrEpoch, getCustomFieldByKey, emptyStringIfNull, formatDateToDDMMYYYYFrEpoch } from '../../utils/util'
export default function RemoveDeviceDetailView(props) {
    const { activity, device, files } = props;
    const { t } = useTranslation();
    const { palette } = useTheme();
    console.log('activityRemoveDetail:', activity);
    console.log('device:', device);
    const [note, setNote] = useState(null);
    const [customFieldNote, setCustomFieldNote] = useState(null)

    const onChangeNote = (event) => {
        setNote(event.target.value);
    }

    useEffect(() => { //text field value doesn't rerender using setState
        const customFieldNote = getCustomFieldByKey(activity.custom_fields, 'notes');
        if (customFieldNote) {
            setCustomFieldNote(customFieldNote);
        }
    }, [])

    const renderState = (type, state) => {
        let label = t(state);
        let color = null;
        switch (type) {
            case "activity":
                color = (state == 'PENDING' ? 'warning' : 'success');
                break;
            case "device":
                color = 'info';
                break;
            case "service":
                color = (state == 'DRAFT' ? 'warning' : (state == 'EFFECTIVE' ? 'success' : 'error'));
        }

        return <Chip label={label} variant='customOutlined' size='small' color={color} />
    }

    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onClose}
            fullWidth={true}
            maxWidth={"md"}
            sx={{ '& .MuiDialog-paper': { padding: '0px 0px' } }}
        >
            <Stack width={'100%'} height={60} flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'} paddingX={2}>
                <IconButton onClick={() => props.onClose()}>
                    <CloseLineIcon />
                </IconButton>
                <Typography variant='body1' marginLeft={1} marginRight={1}>{"Activity " + activity.name}</Typography>
                <Chip label={activity.type.name} variant='customOutlined' size='small' sx={{ backgroundColor: activity.type.colour, color: "#FFFFFF", marginRight: 1 }} />
                {renderState("activity", activity.states[0].state)}
            </Stack>
            <DialogContent dividers={true} sx={{
                padding: '0px 0px'
            }}>
                <Grid xs={12} item container direction={'row'} spacing={2} paddingX={2} paddingY={2}>
                    <Grid xs={12} md={6} item>
                        <Grid xs={12} item component={Paper} paddingX={2} paddingY={2}>
                            <Stack flex={1} direction={'row'} spacing={1}>
                                <UserIcon />
                                <Stack>
                                    <Typography variant='subtitle2'>{activity.contact.person_name.full_name}</Typography>
                                    <Typography variant='subtitle1' sx={{
                                        border: '1px solid',
                                        borderColor: palette.border.main,
                                        paddingX: 0.5,
                                        paddingY: 0,
                                        fontSize: 12,
                                        borderRadius: 1
                                    }}>{activity.contact.code}</Typography>
                                </Stack>
                            </Stack>
                            {activity.contact.email_address && <Stack flex={1} direction={'row'} spacing={1} marginTop={1}>
                                <EmailIcon />
                                <Typography variant='subtitle2'>{activity.contact.email_address}</Typography>
                            </Stack>}
                            {activity.contact.phone && <Stack flex={1} direction={'row'} spacing={1} marginTop={1}>
                                <PhoneIcon />
                                <Typography variant='subtitle2'>{activity.contact.phone.number}</Typography>
                            </Stack>}
                            {activity.address && <Stack flex={1} direction={'row'} spacing={1} mt={1}>
                                <LocationIcon />
                                <Typography variant='subtitle2'>{activity.address.address_line_1 +
                                    emptyStringIfNull(activity.address.address_line_2) +
                                    emptyStringIfNull(activity.address.state_province_county) +
                                    emptyStringIfNull(activity.address.town_city) +
                                    emptyStringIfNull(activity.address.postal_code)}
                                </Typography>
                            </Stack>}
                        </Grid>
                        {device.enabled_services && <Grid xs={12} item component={Paper} paddingX={2} paddingY={2} marginTop={2}>
                            <Stack flex={1} direction={'row'} spacing={1}>
                                <Stack>
                                    <Typography marginBottom={1} variant='subtitle1'>{t('services')}</Typography>
                                    {device.enabled_services.map((service, index) => {
                                        return (
                                            <Stack key={index} direction={'row'} marginBottom={1}>
                                                {service.product && <Typography marginRight={2} variant='subtitle2'>{service.product.name}</Typography>}
                                                {renderState("service", service.life_cycle_state)}
                                            </Stack>
                                        )
                                    })}
                                </Stack>
                            </Stack>
                        </Grid>}
                        <Grid xs={12} item component={Paper} paddingX={2} paddingY={2} marginTop={2}>
                            <Stack flex={1} direction={'row'} spacing={1}>
                                <Stack>
                                    <Stack direction={'row'} marginBottom={1}>
                                        <Typography marginRight={2} variant='subtitle1'>{t('device_removed')}</Typography>
                                        {device.status && renderState("device", device.status.name)}
                                    </Stack>
                                    {device.serial_number && <Typography variant='subtitle2' marginBottom={0.5}>{t('serial_number')}: {device.serial_number}</Typography>}
                                    {device.product && device.product.name && <Typography variant='subtitle2'>{t('product')}: {device.product.name}</Typography>}
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid xs={12} md={6} item>
                        <Grid xs={12} item component={Paper} paddingX={2} paddingY={2}>
                            {activity.description && <Stack marginBottom={1}>
                                <Typography variant='subtitle2'>{t('description') + ':'}</Typography>
                                <Typography variant='subtitle2'>{activity.description}</Typography>
                            </Stack>}
                            <Stack direction={'row'} spacing={1} marginBottom={0.5}>
                                <CalendarIcon />
                                <Typography variant='subtitle2'>{t('created_date') + ': '}</Typography>
                                <Typography variant='subtitle2'>{formatDateToDDMMYYYYHHSSFrEpoch(activity.created_date)}</Typography>
                            </Stack>
                            <Stack direction={'row'} spacing={1} marginBottom={0.5}>
                                <ClockIcon />
                                <Typography variant='subtitle2'>{t('scheduled_date') + ': '}</Typography>
                                <Typography variant='subtitle2'>{formatDateToDDMMYYYYFrEpoch(activity.date) + (activity.from_time ? ` at ${activity.from_time}` : ' All day') + (activity.to_time ? ` - ${activity.to_time}` : '')}</Typography>
                            </Stack>
                            <Grid xs={12} item marginTop={1}>
                                <Typography marginBottom={0.5} variant='subtitle2'>{t('notes') + ': '}</Typography>
                                <TextField
                                    type={'text'}
                                    multiline={true}
                                    rows={3.2}
                                    onChange={onChangeNote}
                                    value={note}
                                    defaultValue={customFieldNote}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            paddingX: 2,
                                            paddingY: 1
                                        },
                                        '.MuiOutlinedInput-input': {
                                            padding: 0
                                        }
                                    }}
                                />
                                <Stack sx={{ cursor: 'pointer' }} direction={'row'} mt={2} spacing={1}
                                    border={'1px solid ' + palette.border.main}
                                    px={2} py={1}
                                    borderRadius={1}
                                    onClick={() => props.setShowUploadFile(true)}>
                                    <Stack flex={1}>
                                        <Typography variant='subtitle1'>{t('attach_files')}</Typography>
                                    </Stack>
                                    <Stack direction={'row'} flex={0.2} justifyContent='flex-end'>
                                        <PlusIcon />
                                    </Stack>
                                </Stack>
                                <Grid item container xs={12} marginTop={2}>
                                    {files && files.length > 0 && files.map((f, i) => {
                                        return (
                                            <Box key={i} position={'relative'} width={48} height={48} marginRight={1}>
                                                <img alt={f.name} src={f.uri} width={48} height={48} />
                                                <Box position={'absolute'} right={0} top={0} onClick={() => props.onDeleteFile(f)}>
                                                    <Box display={'flex'} my={0.5} mx={0.5} justifyContent={'center'} alignItems='center' width={25} height={25} borderRadius={1} backgroundColor={palette.background.main}>
                                                        <DeleteIcon size={'18px'} />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )
                                    })}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>

            </DialogContent>
            <DialogActions>
                <Grid xs={12} item container direction={'row'} paddingX={2} paddingY={1} justifyContent={'center'}>
                    <Button sx={{ marginRight: 2 }} variant='contained' onClick={() => props.onSubmit(note)}>{t('submit')}</Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}
